import { MantineProvider } from '@mantine/core';
import './App.css';
 import Home from './Home/Home';
import '@mantine/core/styles.css';
//import Tempv2 from './Home/Tempv2';
//import Temp from './Home/Temp';

function App() {
  return (
    <>
      <MantineProvider>
        <Home />
        {/* <Tempv2/> */}
      </MantineProvider>

    </>
  );
}

export default App;
